<mat-card>
  <mat-card-header>
    <mat-card-title>SKILLS & EXPERIENCE</mat-card-title>
    @if (editable()) {
      <button class="usa-button usa-button--secondary" (click)="edit()" style="min-width: 70px;"
        aria-label="Edit Skills">
        <fa-icon [icon]="faEdit" style="color: #216E1F;"></fa-icon>&nbsp;Edit
      </button>
    }
  </mat-card-header>
  <mat-card-content>

    <div class="data-column">
      <div class="data-div">
        <p class="data-title">BAER IQCS Qualifications</p>
        <div class="available-list">
          @if (user().BAS) {
            <mat-chip>BAER Specialist - Fireline (BAES)</mat-chip>
          }
          @if (user().BADO) {
            <mat-chip>BAER Documentation Specialist - Office (BADO)</mat-chip>
          }
          @if (user().BAEL) {
            <mat-chip>BAER Team Leader (BAEL)</mat-chip>
          }
          @if (!user().BAS && !user().BADO && !user().BAEL) {
            <p>--</p>
          }
        </div>
      </div>
      <div class="skill-list">
        <div class="data-title" style="padding-top: 0px;">BAER Skills/Roles</div>
        <div class="data-title" style="padding-top: 0px;">Experience level <div class="data-subtitle"
        style="flex: 100%; padding-left: 0px;">(# of assignments)</div>
      </div>
      @for (skill of skills_list; track skill) {
        <div>{{skill.text | skills}}</div>
        @if (skill.experience) {
          <div>{{skill.experience}}</div>
        }
        @if (!skill.experience) {
          <div>--</div>
        }
      }
    </div>
  </div>
  <div class="data-column">
    <div class="data-div">
      <div class="data-title">
        <div style="max-width: 300px;">Experience with large or complex fires </div>
        <div class="data-subtitle">(150,000+ acres)</div>
      </div>
      @if (user().large_fire_exp != null) {
        <p class="data-info">{{user().large_fire_exp | bool_yes_no}}</p>
      }
      @if (user().large_fire_exp === null) {
        <p class="data-info">--</p>
      }
    </div>
    <div class="data-div">
      <div class="data-title">GACC/Dispatch Unit</div>
      <p class="data-info">{{gaccText}}</p>
    </div>
    <div class="data-div">
      <div class="data-title">IQCS Employee ID</div>
      <p class="data-info">{{user().IQCS_employee_id ?? '--'}}</p>
    </div>
    <div class="data-div">
      <div class="data-title">List other IQCS qualifications on your red card</div>
      @if ((user().red_card_qualifications ?? '') != '') {
        <p class="data-info">{{user().red_card_qualifications}}</p>
      }
      @if ((user().red_card_qualifications ?? '') === '') {
        <p class="data-info">--</p>
      }
    </div>
    <div class="data-div">
      <div class="data-title">List BAER Coordinator, Team Lead, or Lead Resource Advisor references</div>
      @if ((user().team_references ?? '') != '') {
        <p class="data-info">{{user().team_references}}</p>
      }
      @if ((user().team_references ?? '') === '') {
        <p class="data-info">--</p>
      }
    </div>
    <div class="data-div">
      <div class="data-title">Additional details</div>
      @if ((user().skills_add_comments ?? '') != '') {
        <p class="data-info">{{user().skills_add_comments}}</p>
      }
      @if ((user().skills_add_comments ?? '') === '') {
        <p class="data-info">--</p>
      }
    </div>
    <div class="data-div" style="display: flex; flex-wrap: wrap;">
      <div class="data-title" style="width: 100%;">GIS Roles</div>
      <br />
      <p style="width: 50%;">
        NIS-BAER: {{user().NIS_BAER || 'false'}}
      </p>
      @if (user().VGIS) {
        <p>
          VGIS: {{user().VGIS || 'false'}}
        </p>
      }
    </div>
  </div>
  <div class="data-div" style="padding-top: 20px; flex:100%;">
    <div class="data-title">Other<div class="data-subtitle">(Other skills and level of experience)</div>
  </div>
  @if ((user().skills_text ?? '') != '') {
    <p class="data-info">{{user().skills_text}}</p>
  }
  @if ((user().skills_text ?? '') === '') {
    <p class="data-info">--</p>
  }
</div>

<div class="data-column">
  <div class="skill-list">
    <div class="data-title" style="padding-top: 5px;">Resource Advisors Skills/Roles</div>
    <div class="data-title" style="padding-top: 5px;">Experience level <div class="data-subtitle"
    style="flex: 100%; padding-left: 0px;">(# of assignments)</div>
  </div>
  @for (skill of skills_list_advisors; track skill) {
    <div>{{skill.text}}</div>
    @if (skill.experience) {
      <div>{{skill.experience}}</div>
    }
    @if (!skill.experience) {
      <div>--</div>
    }
  }
</div>
<div class="data-div">
  <p class="data-title">Resource Advisor Skills/Roles</p>
  <div class="available-list">
    @if (user().archaeology_heritage_tribal) {
      <mat-chip>Archaeology/Heritage/Tribal</mat-chip>
    }
    @if (user().botany_invasives) {
      <mat-chip>Botany/Invasives</mat-chip>
    }
    @if (user().lead_read) {
      <mat-chip>Lead READ</mat-chip>
    }
    @if (user().roads_engineering) {
      <mat-chip>Roads/Engineering</mat-chip>
    }
    @if (user().suppression_repair) {
      <mat-chip>Suppression Repair</mat-chip>
    }
    @if (user().timber) {
      <mat-chip>Timber</mat-chip>
    }
    @if (user().trails_recreation) {
      <mat-chip>Trails/Recreation</mat-chip>
    }
    @if (user().watershed_fisheries_ais) {
      <mat-chip>Watershed/Fisheries/AIS</mat-chip>
    }
    @if (user().wilderness) {
      <mat-chip>Wilderness</mat-chip>
    }
    @if (user().wildlife) {
      <mat-chip>Wildlife</mat-chip>
    }
    @if (!user().archaeology_heritage_tribal &&
      !user().botany_invasives &&
      !user().lead_read &&
      !user().roads_engineering &&
      !user().suppression_repair &&
      !user().timber &&
      !user().trails_recreation &&
      !user().watershed_fisheries_ais &&
      !user().wilderness &&
      !user().wildlife) {
      <p>--</p>
    }
  </div>
</div>
</div>
<div class="data-div" style="padding-top: 20px; flex:100%;">
  <div class="data-title">READ Notes <div class="data-subtitle">(Specialty area details)</div>
</div>
@if ((user().read_text ?? '') != '') {
  <p class="data-info">{{user().read_text}}</p>
}
@if ((user().read_text ?? '') === '') {
  <p class="data-info">--</p>
}
</div>
</mat-card-content>
</mat-card>